import { render, staticRenderFns } from "./saled.vue?vue&type=template&id=0f0ba400&scoped=true"
import script from "./saled.vue?vue&type=script&lang=js"
export * from "./saled.vue?vue&type=script&lang=js"
import style0 from "./saled.vue?vue&type=style&index=0&id=0f0ba400&prod&scoped=true&lang=css"
import style1 from "./saled.vue?vue&type=style&index=1&id=0f0ba400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ba400",
  null
  
)

export default component.exports